import setAllocationTeamMembers from './setAllocationTeamMembers';
import setActTeamMembers from './setActTeamMembers';
import setAvailableActTeamMembers from './setAvailableActTeamMembers';
import setActTeamMember from './setActTeamMember';
import activateTeamMember from './activateTeamMember';
import deactivateTeamMember from './deactivateTeamMember';
import resetPagination from './resetPagination';
import setClinicMembers from './setClinicMembers';
import restoreTeamMember from './restoreTeamMember';
import restoreGlobalUser from './restoreGlobalUser';

export default {
  setAllocationTeamMembers,
  setActTeamMembers,
  setAvailableActTeamMembers,
  setActTeamMember,
  activateTeamMember,
  deactivateTeamMember,
  resetPagination,
  setClinicMembers,
  restoreTeamMember,
  restoreGlobalUser,
};
